<template>
<div id="app">
    <el-row class="row-c">
        <el-col class="col-c" :xs="{span: 24}" :sm="{span:14,offset:4}" :md="{span:12,offset:6}" :lg="{span:8,offset:8}">
            <div class="reel" :style="'top:'+clientTop+'px'">
                <div class="reel-bg"></div>
            </div>

            <div style="margin:0 15px; padding:0 .5em;margin-top:-15px; padding-bottom:20px;position:relative">
                <img style="width:100%;height:auto" src="https://cst-media.oss-cn-hangzhou.aliyuncs.com/guodi/B54hJaMEYe.jpg" />
                <div class="mask" :style="'height:'+ maskHeight +'px;top:'+maskTop+'px'"></div>
            </div>

        </el-col>
    </el-row>
    <div id="playerControls" @click="playMusic()"> <img src="./assets/sound.png" /> <audio :src="audioSrc" ref="player"></audio> </div>
    
</div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            clientTop: 0,
            maskHeight: 0,
            maskTop: 0,
            play: false,
            audioSrc: 'https://web.cst123.cn/xinhe/audio.mp3',
        }
    },
    mounted() {
        if (!CSS.supports('animation-timeline: scroll()')) {
            const bg = document.querySelector('.reel-bg')
            window.addEventListener('scroll', function () {
                bg.style.transform = `translateY(${this.scrollY / Math.PI % 184 / 368 * 100 - 80}%)`
            })
        }
        let height = window.innerHeight;
        this.maskHeight = height - 28
        this.maskTop = 14
        let count = 500
        let step = (height - 28) / count;
        var timer = setInterval(() => {
            this.clientTop += step
            this.maskHeight -= step
            this.maskTop += step
            count--
            if (count == 0) {
                this.maskHeight = 0
                clearInterval(timer)
            }
        }, 10);
        this.share()
    },
    methods: {
        share() {
            let url = window.location.href
            let ws = new WebSocket('wss://apiv4.cst123.cn/hzaccounts/ws/token')
            ws.onerror = (e) => {
                console.log(e)
            }
            ws.onopen = () => {
                console.log('open')
                ws.send(url)
            }
            ws.onmessage = (e) => {
                console.log("share", e)
                let config = JSON.parse(e.data)
                config.jsApiList = ["updateAppMessageShareData", "updateTimelineShareData", 'onMenuShareTimeline', 'onMenuShareAppMessage']
                config.openTagList = ["wx-open-launch-app"]
                config.debug = false
                wx.config(config)
                wx.ready(() => {
                    wx.updateTimelineShareData({
                        title: '唱好杭甬“双城记”特别策划',
                        link: location.href,
                        imgUrl: 'https://web.cst123.cn/xinhe/share.jpg',
                        success() {}
                    });
                    wx.updateAppMessageShareData({
                        title: '唱好杭甬“双城记”特别策划',
                        desc: '',
                        link: location.href,
                        imgUrl: 'https://web.cst123.cn/xinhe/share.jpg',
                        success() {}
                    });
                })
                wx.error(e => {
                    console.log("微信分享设置失败")
                })
            }
            ws.onclose = () => {
                console.log('close')
            }
        },
        playMusic() {
            const audio = this.$refs.player;
            console.log(audio)
            if (this.play) {
                audio.pause()
                this.play = false
                document.getElementById('playerControls').classList.remove('playing')
            } else {
                audio.play()
                this.play = true
                document.getElementById('playerControls').classList.add('playing')
            }
            // document.getElementById('playerControls').classList.toggle('playing')
          }
    },
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100%;
}

.row-c {
    height: 100%
}

.col-c {
    background: white;
}

html,
body {
    background: #ccc;
    margin: 0;
    height: 100%;
}

/*.col-c::before{
  content: '';
  display: block;
  height: 10px;
  background-color: white;
  position: sticky;
  top: 0;
}
  */
.reel {
    position: sticky;
    top: 0;
    height: 28px;
    margin: 0 15px;
    --p: 5;
    border-radius: 1px;
    border-image: url("https://imgservices-1252317822.image.myqcloud.com/coco/s04232024/c510959b.0txvec.png") fill 40 36/14px 12px/0 12px;
    box-shadow: 0 5px 10px 5px rgba(0, 0, 0, .3), 0 10px 20px 10px rgba(0, 0, 0, .5);
    overflow: hidden;
    z-index: 99;
}

.mask {
    height: calc(100% - 28px);
    background: white;
    position: absolute;
    top: 28px;
    width: 100%;
}

.anim {
    height: 100%;
}

.reel-bg {
    position: absolute;
    left: 0;
    width: 100%;
    height: 368px;
    background: url("https://imgservices-1252317822.image.myqcloud.com/coco/s04232024/682ad393.to0id6.jpg") 50% 0/auto 50%;
    mix-blend-mode: multiply;
}

@supports (animation-timeline: scroll()) {
    .reel-bg {
        --s: 999999;
        animation: scroll 1s linear forwards calc(var(--s)/184/3.14);
        animation-timeline: scroll(root);
        animation-range: 0 calc(var(--s) * 1px);
    }
}

@keyframes scroll {
    0% {
        transform: translateY(-80%);
    }

    100% {
        transform: translateY(-30%);
    }
}

::-webkit-scrollbar {
    display: none;
}

#playerControls {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #999;
    overflow: hidden;
}

#playerControls img {
    width: 100%;
    height: 100%;
    transform: rotate(90deg);
}

.playing {
    animation: rotate 5s linear infinite;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue